import { render, staticRenderFns } from "./ReviewEditor.vue?vue&type=template&id=3af2d050&scoped=true&"
import script from "./ReviewEditor.vue?vue&type=script&lang=js&"
export * from "./ReviewEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReviewEditor.vue?vue&type=style&index=0&id=3af2d050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2d050",
  null
  
)

export default component.exports